import React from 'react';
import noop from 'lodash/noop';
import { ERROR_THRESHOLD_TYPE } from '@components/noc-metric-panel/utils/constants';

export type CellData = { conviva: number; custom?: number | string; isCustomSelected: boolean };

export type ThresholdParams =
  | {
      configs: {
        identifier: string;
        data: { custom?: number | string; isCustomSelected: boolean };
      }[];
      type: 'threshold_baseline';
      validate?: (v: number) => { type: ERROR_THRESHOLD_TYPE; pass: boolean };
    }
  | {
      configs: {
        identifier: string;
        data: { custom?: number | string; isCustomSelected: boolean };
        metric: string;
      }[];
      type: 'thresholds';
      validate?: (v: number) => { type: ERROR_THRESHOLD_TYPE; pass: boolean };
    };

export type ThresholdError = {
  threshold_baseline: Record<string, ERROR_THRESHOLD_TYPE | ''>;
  thresholds: Record<string, Record<string, ERROR_THRESHOLD_TYPE | ''>>;
};

type Config = {
  [key in keyof ThresholdError]: any;
};

interface ParentContext {
  thresholdConfig: Config;
  error: ThresholdError;
  setThresholdConfig: (config: Config) => void;
  handleThresholdUpdate: (params: ThresholdParams) => void;
  reset: () => void;
  hasError: boolean;
}

export default React.createContext<ParentContext>({
  thresholdConfig: {
    threshold_baseline: {},
    thresholds: {},
  },
  reset: noop,
  setThresholdConfig: noop,
  error: {
    threshold_baseline: {},
    thresholds: {},
  },
  handleThresholdUpdate: noop,
  hasError: false,
});
